import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const BuscadorNotificacionesService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Notificacion/BuscadorNotificaciones",
            values, customConfig
        );
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { BuscadorNotificacionesService };